import { render, staticRenderFns } from "./videoScreenshot.vue?vue&type=template&id=4e134720&scoped=true"
import script from "./videoScreenshot.vue?vue&type=script&lang=js"
export * from "./videoScreenshot.vue?vue&type=script&lang=js"
import style0 from "./videoScreenshot.vue?vue&type=style&index=0&id=4e134720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e134720",
  null
  
)

export default component.exports